import { AssetInspectionAndControlEnum } from '../../core/models/enum/assets-control';
import { BuildingControlEnum } from '../../core/models/enum/building-control';
import { buildingRegistrationDetailsEnum } from '../../core/models/enum/building-enum';
import { BuildingReturnTabEnum } from '../../core/models/enum/building-return-enum';
import {
  AssetRequirementsEnum,
  SellReturnBuildingEnum,
} from '../../core/models/enum/menus-access-right';
import { RequirementsEnum } from '../../core/models/enum/notify-requirements-enum';
import { ISidebarMenu } from '../../core/models/interface/sidebar/sidebar-menu';

export const sidebarMenus: ISidebarMenu[] = [
  {
    mainMenuId: 1,
    title: 'จัดการสิทธ์การใช้งาน',
    iconImg: 'sitemap',
    expanded: false,
    mainMenus: [
      { subMenuId: 1, title: 'สิทธิ์การเข้าถึงเมนู', link: '/permissions' },
      { subMenuId: 2, title: 'กลุ่มสิทธิ์การใช้งาน', link: '/approve' },
    ],
  },
  {
    mainMenuId: 2,
    subMenuId: 3,
    title: 'จัดการบัญชีผู้ใช้งานระบบ',
    link: '/users',
    iconImg: 'users',
    expanded: false,
    mainMenus: [],
  },
  {
    mainMenuId: 3,
    title: 'การจัดการข้อมูลพื้นฐาน',
    iconImg: 'files-landscapes',
    expanded: false,
    mainMenus: [
      { subMenuId: 4, title: 'หน่วยงาน', link: '/departments' },
      { subMenuId: 5, title: 'แหล่งของเงิน', link: '/asset-acquisition-funds' },
      { subMenuId: 6, title: 'โครงการ/กิจกรรม', link: '/projects' },
      { subMenuId: 7, title: 'วัสดุ', link: '/materials' },
      { subMenuId: 8, title: 'ครุภัณฑ์', link: '/assets' },
      { subMenuId: 9, title: 'รถ (กรมการขนส่งทางบก)', link: '/vehicles' },
      {
        subMenuId: 10,
        title: 'ที่ดินและสิ่งปลูกสร้าง',
        link: '/land-buildings',
      },
    ],
  },
  {
    mainMenuId: 4,
    title: 'บริหารจัดการวัสดุ',
    iconImg: 'pen',
    expanded: false,
    menu_code: 'm_material',
    mainMenus: [
      {
        subMenuId: 11,
        title: 'ทะเบียนคุมวัสดุ',
        expanded: false,
        menu_code: 's_material_registration',
        subMenus: [
          {
            childSubMenuId: 1,
            title: 'ทะเบียนคุมวัสดุทั้งกรม',
            link: '/all-org-inventory-controls',
            menu_code: 'c_material_all',
          },
          {
            childSubMenuId: 2,
            title: 'ทะเบียนคุมวัสดุ',
            link: '/org-inventory-controls',
            menu_code: 'c_material_agency',
          },
        ],
      },
      { subMenuId: 12, title: 'แจ้งความต้องการ', link: '/notify-requirements',
        menu_code: 's_material_request'
      },
      { subMenuId: 13, title: 'ตรวจรับวัสดุ', link: '/material-inspection',
        menu_code: 's_material_inspection'
      },
      {
        subMenuId: 14,
        title: 'เบิกวัสดุ',
        link: '/general-materials-requisition',
        menu_code: 's_material_withdraw'
      },
      { subMenuId: 15, title: 'ตรวจนับประจำปี', link: '/annual-audit',
        menu_code: 's_material_count'
      },
      { subMenuId: 16, title: 'Dashboard', link: '/material-dashboard',
        menu_code: 's_material_dashboard'
      },
      { subMenuId: 17, title: 'รายงาน', link: '/material-report',
        menu_code: 's_material_dashboard'
      },
    ],
  },
  {
    mainMenuId: 5,
    title: 'บริหารจัดการครุภัณฑ์และรถราชการฯ',
    iconImg: 'newspaper',
    expanded: false,
    menu_code: 'm_da',
    mainMenus: [
      { subMenuId: 18,
        title: 'ทะเบียนคุมครุภัณฑ์',
        link: '/asset-control',
        menu_code: 's_da_registration',
      },
      {
        subMenuId: 19,
        title: 'บันทึกรายการสินทรัพย์',
        link: '/asset-inspection',
        menu_code: 's_da_inspection',
      },
      { subMenuId: 20,
        title: 'การเบิกครุภัณฑ์',
        link: '/asset-withdraw',
        menu_code: 's_da_withdraw',
      },
      {
        subMenuId: 21,
        title: 'การยืม-คืนครุภัณฑ์',
        expanded: false,
        menu_code: 's_da_lend',
        subMenus: [
          {
            childSubMenuId: 24,
            title: 'ยืมใช้ภายในหน่วยงาน/ใช้นอกสถานที่',
            link: '/internal-rent-asset-request',
            menu_code: 'c_da_lend_agency',
          },
          {
            childSubMenuId: 25,
            title: 'ยืมระหว่างหน่วยงานของรัฐ',
            link: '/government-rent-asset-request',
            menu_code: 'c_da_lend_gove',
          },
          {
            childSubMenuId: 26,
            title: 'กลุ่มเกษตรกร/สหกรณ์ยืม',
            link: '/farmer-rent-asset-request',
            menu_code: 'c_da_lend_agri',
          },
        ],
      },
      {
        subMenuId: 22,
        title: 'คลังครุภัณฑ์ (ส่งคืน)',
        link: '/return-depot-asset',
        menu_code: 's_da_treasury',
      },
      {
        subMenuId: 23,
        title: 'การขออนุญาตใช้รถราชการ',
        link: '/asset-government-vehicle',
        menu_code: 's_da_car',
      },
      { subMenuId: 24,
        title: 'ตรวจนับประจำปี',
        link: '/asset-annual-count',
        menu_code: 's_da_count',
      },
      { subMenuId: 25,
        title: 'Dashboard',
        link: '/asset-dashboard',
        menu_code: 's_dashboard',
      },
      { subMenuId: 26,
        title: 'รายงาน',
        link: '/asset-report',
        menu_code: 's_report',
      },
    ],
  },
  {
    mainMenuId: 6,
    title: 'บริหารจัดการที่ดิน อาคารและสิ่งปลูกสร้าง',
    iconImg: 'home',
    expanded: false,
    menu_code: 'm_land',
    mainMenus: [
      { subMenuId: 27,
        title: 'ทะเบียนคุมที่ดิน',
        link: '/land-control',
        menu_code: 's_land_registration',
      },
      {
        subMenuId: 28,
        title: 'ทะเบียนคุมอาคารและสิ่งปลูกสร้าง',
        link: '/building-registration',
        menu_code: 's_land_registration_building',
      },
      {
        subMenuId: 29,
        title: 'บันทึกรายการสินทรัพย์',
        link: '/building-inspection',
        menu_code: 's_land_inspection',
      },
      {
        subMenuId: 30,
        title: 'การยืม-คืน อาคารและสิ่งปลูกสร้าง',
        expanded: false,
        menu_code: 's_land_lend',
        subMenus: [
          {
            childSubMenuId: 40,
            title: 'ยืมใช้ภายในหน่วยงาน/ใช้นอกสถานที่',
            link: '/borrowing/internal-borrowing',
            menu_code: 'c_land_lend_agency',
          },
          {
            childSubMenuId: 41,
            title: 'ยืมระหว่างหน่วยงานของรัฐ',
            link: '/borrowing/state-borrowing',
            menu_code: 'c_land_lend_gove',
          },
          {
            childSubMenuId: 42,
            title: 'กลุ่มเกษตรกร/สหกรณ์ยืม',
            link: '/borrowing/farmer-borrowing',
            menu_code: 'c_land_lend_agri',
          },
        ],
      },
      {
        subMenuId: 31,
        title: 'คลังอาคารและสิ่งปลูกสร้าง (ส่งคืน)',
        link: '/building-inventory-return',
        menu_code: 's_land_treasury',
      },
      {
        subMenuId: 32,
        title: 'ตรวจนับประจำปี',
        link: '/building-annual-audit',
        menu_code: 's_land_count',
      },
      { subMenuId: 33,
        title: 'Dashboard',
        link: '/land-building-dashboard',
        menu_code: 's_land_dashboard',
      },
      { subMenuId: 34,
        title: 'รายงาน',
        link: '/land-building-report',
        menu_code: 's_land_report',
      },
    ],
  },
  {
    mainMenuId: 7,
    subMenuId: 35,
    title: 'แบบแจ้งขอแก้ไขข้อมูล',
    iconImg: 'pen',
    link: '/correction-request/list',
    expanded: false,
    menu_code: 'm_request',
    mainMenus: [
      // {
      //   subMenuId: 35,
      //   title: 'บันทึกแบบขอเเจ้งแก้ไขข้อมูล',
      //   link: '/correction-request-record',
      // },
      // { subMenuId: 36, title: 'รายงาน', link: '/correction-request-report' },
    ],
  },
  {
    mainMenuId: 8,
    subMenuId: 36,
    title: 'คู่มือการใช้งาน',
    link: '/user-manual',
    iconImg: 'user-manual',
    expanded: false,
    mainMenus: [],
  },
];

export const childSubMenuIdMap: Record<number, string> = {
  // RequirementsEnum -เเจ้งความต้องการ
  //subMenuId: 12
  3: RequirementsEnum.MaterialsList,
  4: RequirementsEnum.NotifyRequirements,
  5: RequirementsEnum.historyRequirements,
  6: RequirementsEnum.ConsiderPurchase,
  7: RequirementsEnum.TrackStatus,

  // AssetRequirementsEnum - ทะเบียนคุมครุภัณฑ์
  //subMenuId: 18
  8: AssetRequirementsEnum.INFORMATION,
  9: AssetRequirementsEnum.EQUIPMENT_HISTORY,
  10: AssetRequirementsEnum.VEHICLE_USAGE_HISTORY,
  11: AssetRequirementsEnum.MAINTENANCE,
  12: AssetRequirementsEnum.FUEL_USAGE,
  13: AssetRequirementsEnum.TIRE_USAGE_STATS,
  14: AssetRequirementsEnum.BATTERY_USAGE_STATS,
  15: AssetRequirementsEnum.ACCIDENT_REPORTS,
  16: AssetRequirementsEnum.VEHICLE_INSPECTION,
  17: AssetRequirementsEnum.INSURANCE_AND_ACT,
  18: AssetRequirementsEnum.POLLUTION_CHECK,

  // AssetInspectionAndControlEnum - บันทึกรายการสินทรัพย์
  //subMenuId: 19
  19: AssetInspectionAndControlEnum.WaitingSubmit,
  20: AssetInspectionAndControlEnum.Donate,
  21: AssetInspectionAndControlEnum.Transfer,
  22: AssetInspectionAndControlEnum.Discovered,
  23: AssetInspectionAndControlEnum.WaitingTransfer,

  //SellReturnBuildingEnum - คลังครุภัณฑ์ (ส่งคืน)
  //subMenuId: 22
  27: SellReturnBuildingEnum.INVENTORY_LIST,
  28: SellReturnBuildingEnum.RETURN_LIST,
  29: SellReturnBuildingEnum.WITHDRAWAL_LIST,
  30: SellReturnBuildingEnum.DISPOSAL_LIST,

  // buildingRegistrationDetailsEnum - ทะเบียนคุมอาคารและสิ่งปลูกสร้าง
  //subMenuId: 28
  31: buildingRegistrationDetailsEnum.WaitingSubmit,
  32: buildingRegistrationDetailsEnum.Donate,
  33: buildingRegistrationDetailsEnum.Transfer,
  34: buildingRegistrationDetailsEnum.Discovered,

  // BuildingControlEnum - บันทึกรายการสินทรัพย์
  //subMenuId: 29
  35: BuildingControlEnum.WaitingSubmit,
  36: BuildingControlEnum.Donate,
  37: BuildingControlEnum.Transfer,
  38: BuildingControlEnum.Discovered,
  39: BuildingControlEnum.WaitTransfer,

  // BuildingReturnTabEnum - คลังอาคารและสิ่งปลูกสร้าง (ส่งคืน)
  //subMenuId: 31
  43: BuildingReturnTabEnum.WAREHOUSE_RETURN,
  44: BuildingReturnTabEnum.RETURN,
  45: BuildingReturnTabEnum.REQUISITION_EXTENSION,
  46: BuildingReturnTabEnum.DISPOSE,
};

export const subMenuToChildIdsMap: Record<number, number[]> = {
  12: [3, 4, 5, 6, 7], // RequirementsEnum -เเจ้งความต้องการ
  18: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18], //  AssetRequirementsEnum - ทะเบียนคุมครุภัณฑ์
  19: [19, 20, 21, 22, 23], //  AssetInspectionAndControlEnum - บันทึกรายการสินทรัพย์
  22: [27, 28, 29, 30], // SellReturnBuildingEnum - คลังครุภัณฑ์ (ส่งคืน)
  28: [31, 32, 33, 34], // buildingRegistrationDetailsEnum - ทะเบียนคุมอาคารและสิ่งปลูกสร้าง
  29: [35, 36, 37, 38, 39], //  BuildingControlEnum - บันทึกรายการสินทรัพย์
  31: [43, 44, 45, 46], // BuildingReturnTabEnum - คลังอาคารและสิ่งปลูกสร้าง (ส่งคืน)
};

export const allSubMenusToChildIdsMapRecord: Record<number, number[]> = {
  1: [], // สิทธิ์การเข้าถึงเมนู
  2: [], // กลุ่มสิทธิ์การใช้งาน
  3: [], // จัดการบัญชีผู้ใช้งานระบบ
  4: [], // หน่วยงาน
  5: [], // แหล่งของเงิน
  6: [], // โครงการ/กิจกรรม
  7: [], //  วัสดุ
  8: [], // ครุภัณฑ์
  9: [], // รถ (กรมการขนส่งทางบก)
  10: [], //  ที่ดินและสิ่งปลูกสร้าง
  11: [1, 2], //  ทะเบียนคุมวัสดุ
  12: [3, 4, 5, 6, 7], // RequirementsEnum -เเจ้งความต้องการ
  13: [], // ตรวจรับวัสดุ
  14: [], //   เบิกวัสดุ
  15: [], // ตรวจนับประจำปี
  16: [], // Dashboard
  17: [], //   รายงาน
  18: [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18], //  AssetRequirementsEnum - ทะเบียนคุมครุภัณฑ์
  19: [19, 20, 21, 22, 23], //  AssetInspectionAndControlEnum - บันทึกรายการสินทรัพย์
  20: [], // การเบิกครุภัณฑ์
  21: [24, 25, 26], //   การยืม-คืนครุภัณฑ์
  22: [27, 28, 29, 30], // SellReturnBuildingEnum - คลังครุภัณฑ์ (ส่งคืน)
  23: [], // การขออนุญาตใช้รถราชการ
  24: [], //   ตรวจนับประจำปี
  25: [], // Dashboard
  26: [], // รายงาน
  27: [], //   ทะเบียนคุมที่ดิน
  28: [31, 32, 33, 34], // buildingRegistrationDetailsEnum - ทะเบียนคุมอาคารและสิ่งปลูกสร้าง
  29: [35, 36, 37, 38, 39], //  BuildingControlEnum - บันทึกรายการสินทรัพย์,
  30: [40, 41, 42, 46], // การยืม-คืน อาคารและสิ่งปลูกสร้าง
  31: [43, 44, 45, 46], // BuildingReturnTabEnum - คลังอาคารและสิ่งปลูกสร้าง (ส่งคืน)
  32: [], // ตรวจนับประจำปี
  33: [], //  Dashboard
  34: [], // รายงาน
  35: [], // บันทึกแบบขอเเจ้งแก้ไขข้อมูล
  36: [], //   รายงาน
};
